'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _dec, _dec2, _class, _class2, _temp;

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n    query getMe {\n      me {\n        _id\n        roles\n        emails {\n          address\n          verified\n        }\n      }\n    }\n  '], ['\n    query getMe {\n      me {\n        _id\n        roles\n        emails {\n          address\n          verified\n        }\n      }\n    }\n  ']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  mutation resendVerificationEmail($email: String) {\n    resendVerificationEmail(email: $email) {\n      success\n    }\n  }\n'], ['\n  mutation resendVerificationEmail($email: String) {\n    resendVerificationEmail(email: $email) {\n      success\n    }\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _withGraphQL = require('react-apollo-decorators/lib/withGraphQL');

var _withGraphQL2 = _interopRequireDefault(_withGraphQL);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _withMutation = require('react-apollo-decorators/lib/withMutation');

var _withMutation2 = _interopRequireDefault(_withMutation);

var _Provider = require('./Provider');

var _Provider2 = _interopRequireDefault(_Provider);

var _Loading = require('./Loading');

var _Loading2 = _interopRequireDefault(_Loading);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Layout = (_dec = (0, _withGraphQL2.default)((0, _graphqlTag2.default)(_templateObject), {
  loading: null,
  networkErrorComponent: null,
  options: { pollInterval: 5000 }
}), _dec2 = (0, _withMutation2.default)((0, _graphqlTag2.default)(_templateObject2)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Layout, _React$Component);

  function Layout() {
    (0, _classCallCheck3.default)(this, Layout);
    return (0, _possibleConstructorReturn3.default)(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).apply(this, arguments));
  }

  (0, _createClass3.default)(Layout, [{
    key: 'render',
    value: function render() {
      if (this.props._data.networkStatus !== 7) return _react2.default.createElement(_Loading2.default, null);
      return _react2.default.createElement(
        _Provider2.default,
        { me: this.props.me, resendVerificationEmail: this.props.resendVerificationEmail },
        this.props.children
      );
    }
  }]);
  return Layout;
}(_react2.default.Component), _class2.propTypes = {
  children: _propTypes2.default.node,
  me: _propTypes2.default.object,
  resendVerificationEmail: _propTypes2.default.func,
  _data: _propTypes2.default.object
}, _temp)) || _class) || _class);
exports.default = Layout;


//////////////////
// WEBPACK FOOTER
// ./node_modules/orionsoft-parts/lib/components/Provider/MeProvider/index.js
// module id = 1201
// module chunks = 85